import { Input, ModalProps } from 'antd';
import { CustomModal } from 'components/molecules/PricingSimulator/Modals/ScenarioColumnEditModal';
import { ChangeEvent, ReactNode } from 'react';

type PopupProps = {
    open: boolean;
    onCancel: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onSubmitClick: (value: string) => void;
    title: string;
    okText: ReactNode;
    subTitle?: string;
    okButtonProps?: ModalProps['okButtonProps'];
    width?: number;
    inputValue: string;
    onInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
};
const InputModal = ({
    open,
    onCancel,
    onSubmitClick,
    okText,
    okButtonProps,
    title,
    width = 400,
    inputValue,
    onInputChange,
}: PopupProps) => {
    return (
        <CustomModal
            width={width}
            cancelButtonProps={{ style: { borderRadius: 6 } }}
            onCancel={(e) => {
                onCancel(e);
            }}
            onOk={() => {
                onSubmitClick(inputValue);
            }}
            title={title}
            centered
            open={open}
            okButtonProps={{ ...okButtonProps, disabled: !inputValue }}
            okText={okText}
        >
            <Input
                placeholder="Enter event name..."
                value={inputValue}
                onChange={onInputChange}
                size="small"
                className="pl-2 m-2 h-8 rounded-sm"
            />
        </CustomModal>
    );
};
export default InputModal;
